'use strict';

var SeasonalityCommonService = function SeasonalityCommonService(momentService) {
  function getFirstMonday(year) {
    var firstMon = momentService.of(year + '-01-04', momentService.FIELD.WEEK_START_DATE, momentService.FORMAT.DATE_ISO);
    return firstMon.startOf('isoWeek');
  }
  function getWeekNumber(moment) {
    return Math.min(moment.isoWeekOfYear(), 52);
  }
  function seasonalityWeekOfYear(date, format) {
    if (momentService.isMoment(date)) {
      return getWeekNumber(date);
    }
    return getWeekNumber(momentService.of(date, format));
  }
  return {
    getFirstMonday: getFirstMonday,
    seasonalityWeekOfYear: seasonalityWeekOfYear
  };
};
SeasonalityCommonService.$inject = ['MomentService'];
module.exports = SeasonalityCommonService;